import React from 'react';
import { map } from 'lodash';
import classnames from 'classnames';

// local dependencies
import { WIDGET_NAMES } from 'constants/entity-names';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { MemberSearchWidget } from 'ui/containers/MemberSearchWidget';
import { memberSearchWidgetPreloader as MemberSearchWidgetPreloader } from 'ui/views/widgets/memberSearchWidget';
import { CallListWidget } from 'ui/containers/CallListWidget';
import { ToDoListWidget } from 'ui/containers/ToDoListWidget';
import { ActionListWidget } from 'ui/containers/ActionListWidget';
import { callListWidgetPreloader as CallListWidgetPreloader } from 'ui/views/widgets/callListWidget';
import { TransferQueueWidget } from 'ui/containers/TransferQueueWidget';

// widget views
const WIDGET_VIEWS = {
    [ WIDGET_NAMES.MEMBER_SEARCH ]: MemberSearchWidget,
    [ WIDGET_NAMES.CALL_LIST ]: CallListWidget,
    
    [ WIDGET_NAMES.TO_DO_LIST ]: ToDoListWidget,
    [ WIDGET_NAMES.TRANSFER_QUEUE ]: TransferQueueWidget,
    [ WIDGET_NAMES.ACTION_LIST ]: ActionListWidget,
};

/*******************************/

// success widget view
export const callManagementListsWidgetSuccess = ( props ) => {
    return (
        <div className='ui-call-management-lists-widget'>
            {
                map( props.widgets, widget => {

                    // get widget view
                    const WidgetView = WIDGET_VIEWS[ widget.name ];

                    // widget class name
                    const widgetClassName = classnames( 'ui-call-management-lists-widget__widget', `ui-call-management-lists-widget__widget--name-${ widget.name }` );

                    return (
                        <div key={ widget.name } className={ widgetClassName }>
                            <WidgetView widget={ widget } />
                        </div>
                    );
                } )
            }
        </div>
    );
};

// set display name
callManagementListsWidgetSuccess.displayName = 'callManagementListsWidgetSuccess';

// set default props
callManagementListsWidgetSuccess.defaultProps = {
    widgets: [],
};

// prop types
callManagementListsWidgetSuccess.propTypes = {};

/*******************************/


// preloader widget view
const callManagementListsWidgetPreloader = () => {
    return (
        <div className='ui-call-management-lists-widget-preloader'>
            <MemberSearchWidgetPreloader className='ui-call-management-lists-widget-preloader__widget'/>
            <CallListWidgetPreloader className='ui-call-management-lists-widget-preloader__widget'/>
        </div>
    );
};

// set display name
callManagementListsWidgetPreloader.displayName = 'callManagementListsWidgetPreloader';

// set default props
callManagementListsWidgetPreloader.defaultProps = {};

// prop types
callManagementListsWidgetPreloader.propTypes = {};


/*******************************/


/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { callManagementListsWidget as CallManagementListsWidget } from 'ui/views/widgets/callManagementListsWidget';
 *
 * // render
 * <CallManagementListsWidget propName='propValue'/>
 */
export const callManagementListsWidget = withNetworkState( callManagementListsWidgetPreloader, callManagementListsWidgetSuccess );
